
// utils/ProtectedRoutes.js
import { Outlet, Navigate } from "react-router-dom";

const ProtectedRoutes = ({ role }) => {
  const token = sessionStorage.getItem("token");
  const userRole = sessionStorage.getItem("role"); 

  console.log("ProtectedRoutes token:", token);
  console.log("ProtectedRoutes userRole:", userRole);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (role && userRole !== role) {
    return role === "superadmin" ? ( <Navigate to="/super-admin" replace />) : (<Navigate to="/" replace />  );
  }

  return <Outlet />;
};

export default ProtectedRoutes;
